import { SelectOptionT } from "../models/models";
import { jumboMediaAPI } from "./service";
import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { CACHE_TTL } from "./cacheConfig";

import type { GenerateBrandAdIdPayloadT, GenerateBrandAdIdResultT } from "./models/models";

export const brandsAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    getBrands: build.query({
      query: (body) =>
        `/api/Brands/DataTablesSource${buildManagePageQueryString(
          body.columns,
          body.page,
          body.searchTerm,
          (body.page - 1) * body.limit,
          body.limit,
          body.orderColumnIndex,
          body.isDescSortDir
        )}`,
      providesTags: ["Brand"],
    }),
    getAllBrands: build.query<
      SelectOptionT[],
      { asSelectOptions: boolean; value?: string }
    >({
      query: (body) => ({
        url: `/api/Brands/UserGetWithValue?value=${body?.value || ""}`,
        responseHandler: (res: any) =>
          res.json().then((res: any) => {
            if (body?.asSelectOptions) {
              return res.map((item: any) => ({
                value: item.Id,
                label: item.Name,
              }));
            } else {
              return res;
              // .map((item: any) => ({ id: item.Id, name: item.Name }))
            }
          }),
      }),
      providesTags: ["Brand"],
      keepUnusedDataFor: CACHE_TTL.LOOKUP,
    }),
    getAllBrandsFull: build.query<
      SelectOptionT[],
      { asSelectOptions: boolean; value?: string }
    >({
      query: (body) => ({
        url: `/api/Brands/UserGet`,
        responseHandler: (res: any) =>
          res.json().then((res: any) => {
            if (body?.asSelectOptions) {
              return res.map((item: any) => ({
                value: item.Id,
                label: item.Name,
              }));
            } else {
              return res;
              // .map((item: any) => ({ id: item.Id, name: item.Name }))
            }
          }),
      }),
      providesTags: ["Brand"],
      keepUnusedDataFor: CACHE_TTL.LOOKUP,
    }),
    createBrandShort: build.mutation({
      query: (body) => ({
        url: `/api/Brands/UserPost`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Brand"],
    }),
    createBrand: build.mutation({
      query: (body) => ({
        url: `/api/Brands/AdminPost`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Brand"],
    }),
    updateBrand: build.mutation({
      query: (body) => {
        return {
          url: `/api/Brands/AdminPut/${body.Id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Brand"],
    }),
    deleteBrand: build.mutation({
      query: (body) => ({
        url: `/api/Brands/AdminDelete/${body.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Brand"],
    }),
    generateBrandAdId: build.mutation<string, GenerateBrandAdIdPayloadT>({
      query: (body) => ({
        url: `/api/Brands/GetGeneratedAdId?name=${body.name}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetBrandsQuery,
  useCreateBrandMutation,
  useDeleteBrandMutation,
  useUpdateBrandMutation,
  useGetAllBrandsQuery,
  useLazyGetAllBrandsQuery,
  useCreateBrandShortMutation,
  useGetAllBrandsFullQuery,
  useGenerateBrandAdIdMutation,
} = brandsAPI;
